import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeModuleComponent } from './home-module.component';

import { DataManagementModule } from '../data-management/data-management.module';
import { SalesDnaModule } from '../sales-dna/sales-dna.module';
import { SettingsModule } from '../settings/settings.module';
import { MaterialModule } from 'src/app/material/material.module';
import { EmplayConsultantComponent } from './components/emplay-consultant/emplay-consultant.component';
import { SideNavComponent } from 'src/app/components/side-nav/side-nav.component';
import { RouterModule } from '@angular/router';
import { HomeModuleRoutingModule } from './home-module-routing.module';
import { StaticSourceDirective } from 'src/app/directives/static-src.directive';




@NgModule({
  declarations: [HomeModuleComponent, EmplayConsultantComponent],
  imports: [
    CommonModule,
    MaterialModule,
    DataManagementModule,
    SalesDnaModule,
    SettingsModule,
    SideNavComponent,
    RouterModule,
    HomeModuleRoutingModule,
    StaticSourceDirective,
  ],
})
export class HomeModuleModule {}
